import React from "react"
import { createRoot } from "react-dom/client"
import ReactGA from "react-ga"
import "./font.css"
import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"

ReactGA.initialize(process.env.REACT_APP_TRACKING_ID)

createRoot(document.getElementById("root")).render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
